var _style, _defs, _circle, _defs2, _polygon, _defs3, _polygon2, _defs4, _polygon3, _defs5, _polygon4, _defs6, _polygon5, _defs7, _polygon6, _defs8, _polygon7, _defs9, _polygon8, _defs0, _polygon9, _defs1, _polygon0, _defs10, _polygon1, _defs11, _polygon10, _defs12, _polygon11, _defs13, _polygon12, _defs14, _polygon13, _defs15, _polygon14, _defs16, _polygon15, _defs17, _polygon16, _defs18, _polygon17, _defs19, _polygon18, _defs20, _polygon19, _defs21, _polygon20, _rect, _polygon21, _polygon22, _polygon23, _g, _defs22, _polygon24;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCandriam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "layer",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 652 652",
    style: {
      enableBackground: "new 0 0 652 652"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);fill:url(#SVGID_3_);}\r\n\t.st1{clip-path:url(#SVGID_5_);fill:url(#SVGID_6_);}\r\n\t.st2{clip-path:url(#SVGID_8_);fill:url(#SVGID_9_);}\r\n\t.st3{clip-path:url(#SVGID_11_);fill:url(#SVGID_12_);}\r\n\t.st4{clip-path:url(#SVGID_14_);fill:url(#SVGID_15_);}\r\n\t.st5{clip-path:url(#SVGID_17_);fill:url(#SVGID_18_);}\r\n\t.st6{clip-path:url(#SVGID_20_);fill:url(#SVGID_21_);}\r\n\t.st7{clip-path:url(#SVGID_23_);fill:url(#SVGID_24_);}\r\n\t.st8{clip-path:url(#SVGID_26_);fill:url(#SVGID_27_);}\r\n\t.st9{clip-path:url(#SVGID_29_);fill:url(#SVGID_30_);}\r\n\t.st10{clip-path:url(#SVGID_32_);fill:url(#SVGID_33_);}\r\n\t.st11{clip-path:url(#SVGID_35_);fill:url(#SVGID_36_);}\r\n\t.st12{clip-path:url(#SVGID_38_);fill:url(#SVGID_39_);}\r\n\t.st13{clip-path:url(#SVGID_41_);fill:url(#SVGID_42_);}\r\n\t.st14{clip-path:url(#SVGID_44_);fill:url(#SVGID_45_);}\r\n\t.st15{clip-path:url(#SVGID_47_);fill:url(#SVGID_48_);}\r\n\t.st16{clip-path:url(#SVGID_50_);fill:url(#SVGID_51_);}\r\n\t.st17{clip-path:url(#SVGID_53_);fill:url(#SVGID_54_);}\r\n\t.st18{clip-path:url(#SVGID_56_);fill:url(#SVGID_57_);}\r\n\t.st19{clip-path:url(#SVGID_59_);fill:url(#SVGID_60_);}\r\n\t.st20{clip-path:url(#SVGID_62_);fill:url(#SVGID_63_);}\r\n\t.st21{clip-path:url(#SVGID_65_);fill:url(#SVGID_66_);}\r\n\t.st22{clip-path:url(#SVGID_68_);fill:url(#SVGID_69_);}\r\n\t.st23{fill:#00466C;}\r\n\t.st24{fill:#0073BB;}\r\n\t.st25{fill:#7C7C7C;}\r\n\t.st26{clip-path:url(#SVGID_71_);fill:url(#SVGID_72_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M566.9,305L566.9,305L566.9,305z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 566.8583,
    y1: 304.9721,
    x2: 566.8665,
    y2: 304.9721,
    gradientTransform: "matrix(-5.925000e-004 -1.024100e-003 1.024100e-003 -5.925000e-004 -98.3144 358.1633)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0080BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5733,
    style: {
      stopColor: "#005996"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00417C"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 566.9,
    cy: 305,
    r: 0
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_4_",
    d: "M558.7,309.9c3.4,2.3,6.6,4.8,9.5,7.7c10.6,10.6,16.8,24.5,17.6,39.3c1.1-0.1,2.2-0.2,3.3-0.3 c-0.9-15.6-7.4-30.2-18.5-41.4c-2.7-2.6-5.5-5.1-8.6-7.2C560.9,308.8,559.8,309.3,558.7,309.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_5_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_4_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: -384.1469,
    y1: 881.2419,
    x2: -376.1304,
    y2: 881.2419,
    gradientTransform: "matrix(-2.8363 -4.9019 4.9019 -2.8363 -4824.7119 967.4953)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0073BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1691,
    style: {
      stopColor: "#006AAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    style: {
      stopColor: "#00507E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00466C"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "610.2,344.7 581.5,295 537.5,320.4 566.3,370.2  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_7_",
    d: "M548.6,314.2c4.9,2.5,9.4,5.7,13.4,9.7c8.9,8.9,14.1,20.5,15,32.9c1.1,0.1,2.2,0.2,3.3,0.3 c-0.8-13.4-6.4-25.9-16-35.5c-3.5-3.5-7.4-6.5-11.6-8.9C551.4,313.2,550,313.7,548.6,314.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: -384.3095,
    y1: 880.1014,
    x2: -376.293,
    y2: 880.1014,
    gradientTransform: "matrix(-2.8284 -4.8881 4.8881 -2.8284 -4812.481 966.3954)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0073BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1691,
    style: {
      stopColor: "#006AAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    style: {
      stopColor: "#00507E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00466C"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "599.6,345.9 572.4,298.9 529.4,323.8 556.6,370.7  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_10_",
    d: "M530.9,317.7C530.9,317.8,530.9,317.8,530.9,317.7c9.5,1.2,18.2,5.5,25,12.3c6.8,6.8,11.1,15.6,12.2,25 c1.1,0.3,2.2,0.6,3.4,0.8c-1-10.6-5.7-20.5-13.3-28.1c-5.1-5.1-11.4-9-18.2-11.2C537,317.1,533.9,317.5,530.9,317.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_11_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_10_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: -384.2922,
    y1: 878.1996,
    x2: -376.2757,
    y2: 878.1996,
    gradientTransform: "matrix(-2.8287 -4.8887 4.8887 -2.8287 -4814.3022 967.2049)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0073BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1691,
    style: {
      stopColor: "#006AAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    style: {
      stopColor: "#00507E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00466C"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "588.5,346 561.3,298.9 513.8,326.4 541,373.5  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_13_",
    d: "M532.9,323.7c0.5,1.3,1.1,2.5,1.7,3.8c5.7,1.5,10.8,4.5,15,8.7c4.2,4.2,7.2,9.4,8.7,15 c1.2,0.6,2.5,1.2,3.8,1.7c-1.4-7.1-4.9-13.8-10.2-19.1C546.7,328.7,540.1,325.1,532.9,323.7L532.9,323.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: -384.5773,
    y1: 878.1104,
    x2: -376.5608,
    y2: 878.1104,
    gradientTransform: "matrix(-2.8131 -4.8617 4.8617 -2.8131 -4788.7788 964.1389)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0073BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1691,
    style: {
      stopColor: "#006AAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    style: {
      stopColor: "#00507E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00466C"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "574.9,345.6 554.8,311 520.2,331 540.3,365.6  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_16_",
    d: "M574.4,294.4c-12,12-27.6,19-44.3,20.1c0.2,0.7,0.6,2.6,0.8,3.3c2.4-0.2,7.6-0.9,9.1-1.3 c3-0.6,5.8-1.4,8.7-2.3c2-0.7,2.9-1,4.1-1.5c2-0.8,4-1.7,5.9-2.7c1.3-0.7,2.7-1.4,3.2-1.8c1.7-1,3.3-2,4.9-3.2 c1.5-1.1,2.3-1.7,2.8-2c2.5-1.9,4.8-4,7.1-6.2c2.2-2.2,4.3-4.6,6.2-7.1c-0.7-0.9-1.4-1.8-2-2.8 C578.9,289.6,576.7,292.1,574.4,294.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_17_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_16_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: -249.0149,
    y1: 838.6999,
    x2: -240.9985,
    y2: 838.6999,
    gradientTransform: "matrix(4.7643 -4.4841 4.4841 4.7643 -2027.4153 -4801.1465)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0073BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.169,
    style: {
      stopColor: "#006AAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7216,
    style: {
      stopColor: "#00507E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    style: {
      stopColor: "#00466C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00466C"
    }
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "554.9,344.2 598.4,303.3 558.1,260.5 514.6,301.4  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_19_",
    d: "M568.2,288.2c-10.6,10.6-24.5,16.8-39.3,17.6c0.1,1.1,0.2,2.2,0.3,3.2c15.6-0.9,30.2-7.4,41.4-18.5 c2.6-2.7,5.1-5.5,7.2-8.6c-0.6-1.1-1.2-2.1-1.8-3.2C573.7,282.1,571.1,285.3,568.2,288.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: -248.0164,
    y1: 838.3358,
    x2: -239.9999,
    y2: 838.3358,
    gradientTransform: "matrix(4.7068 -4.4299 4.4299 4.7068 -2004.7931 -4739.6245)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0073BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.169,
    style: {
      stopColor: "#006AAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7216,
    style: {
      stopColor: "#00507E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    style: {
      stopColor: "#00466C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00466C"
    }
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "551.8,333.5 592.9,294.8 554.8,254.3 513.7,293  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_22_",
    d: "M562,282.1c-8.9,8.9-20.5,14.1-32.9,15c-0.1,1.1-0.2,2.2-0.3,3.3h0c13.4-0.8,25.9-6.4,35.5-16 c3.5-3.5,6.5-7.4,8.9-11.6c-0.6-1.4-1.1-2.7-1.5-4.1C569.2,273.6,566,278.1,562,282.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_23_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_22_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: -247.8015,
    y1: 837.3658,
    x2: -239.785,
    y2: 837.3658,
    gradientTransform: "matrix(4.6939 -4.4178 4.4178 4.6939 -2000.3173 -4726.4565)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0073BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.169,
    style: {
      stopColor: "#006AAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7216,
    style: {
      stopColor: "#00507E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    style: {
      stopColor: "#00466C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00466C"
    }
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "549.7,322.5 589,285.5 552.4,246.5 513.1,283.6  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_25_",
    d: "M568.1,250.9c-1.2,9.4-5.4,18.2-12.2,25c-6.8,6.8-15.5,11.1-25,12.2c-0.3,1.1-0.6,2.3-0.8,3.4 c10.6-1,20.5-5.7,28.1-13.3c5.1-5.1,9-11.4,11.2-18.2C568.8,257,568.4,254,568.1,250.9C568.1,250.9,568.1,250.9,568.1,250.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: -247.9466,
    y1: 835.7974,
    x2: -239.9302,
    y2: 835.7974,
    gradientTransform: "matrix(4.7038 -4.4272 4.4272 4.7038 -2005.226 -4738.1851)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0073BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.169,
    style: {
      stopColor: "#006AAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7216,
    style: {
      stopColor: "#00507E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    style: {
      stopColor: "#00466C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00466C"
    }
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "548.5,311.1 589.6,272.4 550.9,231.2 509.8,270  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs0 || (_defs0 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_28_",
    d: "M558.4,254.7c-1.6,5.7-4.5,10.8-8.7,15c-4.2,4.2-9.4,7.2-15,8.8c-0.6,1.2-1.2,2.5-1.7,3.8l0,0 c7.2-1.4,13.8-4.9,19.1-10.2c5.2-5.2,8.8-11.9,10.2-19.1C560.9,253.5,559.7,254.1,558.4,254.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_29_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_28_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: -247.4825,
    y1: 835.5746,
    x2: -239.466,
    y2: 835.5746,
    gradientTransform: "matrix(4.6775 -4.4023 4.4023 4.6775 -1994.8806 -4709.9922)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0073BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.169,
    style: {
      stopColor: "#006AAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7216,
    style: {
      stopColor: "#00507E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    style: {
      stopColor: "#00466C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00466C"
    }
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "546.7,296.8 576.8,268.5 548.4,238.3 518.3,266.7  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs1 || (_defs1 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_31_",
    d: "M568.1,250.9c0,0,0.4,5.7,1.2,9.1c0.6,2.9,1.4,5.8,2.3,8.7c0.5,1.4,0.8,2.4,1.5,4.1c0.8,2,1.7,4,2.7,5.9 c0.6,1.2,1.1,2.1,1.8,3.2c1,1.7,2,3.3,3.2,4.9c0.6,0.9,1.6,2.2,2,2.8c1.9,2.5,4,4.8,6.2,7.1c2.2,2.2,4.6,4.3,7.1,6.2 c0.9-0.7,1.8-1.4,2.7-2c-2.7-2-5.3-4.2-7.6-6.5c-12-12-19-27.6-20.1-44.4C570.7,250.2,568.1,250.9,568.1,250.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_32_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_31_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: -273.7675,
    y1: 620.8124,
    x2: -265.751,
    y2: 620.8124,
    gradientTransform: "matrix(1.7961 3.7471 -3.7471 1.7961 3398.5015 180.9823)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0073BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1691,
    style: {
      stopColor: "#006AAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    style: {
      stopColor: "#00507E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00466C"
    }
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "547.5,260 573.9,315 619.6,293.1 593.3,238  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_34_",
    d: "M576.8,249.2c0.9,15.6,7.4,30.2,18.5,41.4c2.6,2.7,5.6,5.1,8.6,7.2c1.1-0.6,2.1-1.2,3.2-1.8 c-3.4-2.3-6.6-4.9-9.5-7.8c-10.6-10.6-16.8-24.5-17.6-39.3C578.9,249,577.9,249.1,576.8,249.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_35_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_34_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: -273.5212,
    y1: 618.2862,
    x2: -265.5047,
    y2: 618.2862,
    gradientTransform: "matrix(1.7888 3.7319 -3.7319 1.7888 3385.332 181.2093)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0073BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1691,
    style: {
      stopColor: "#006AAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    style: {
      stopColor: "#00507E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00466C"
    }
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "557.7,258 582.5,309.6 626.2,288.6 601.5,237.1  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_37_",
    d: "M585.5,248.9c0.8,13.4,6.4,25.9,16,35.5c3.5,3.5,7.4,6.5,11.6,8.9c1.3-0.5,2.7-1.1,4.1-1.5 c-4.9-2.5-9.4-5.7-13.4-9.7c-8.9-8.9-14.1-20.5-15-32.9C587.7,249,586.6,248.9,585.5,248.9L585.5,248.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_38_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_37_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: -273.3804,
    y1: 615.8666,
    x2: -265.364,
    y2: 615.8666,
    gradientTransform: "matrix(1.7841 3.7221 -3.7221 1.7841 3377.2668 181.1582)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0073BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1691,
    style: {
      stopColor: "#006AAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    style: {
      stopColor: "#00507E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00466C"
    }
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "568.2,257.2 591.4,305.6 634.5,285 611.3,236.5  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_40_",
    d: "M607.7,278.2c5.1,5.1,11.4,8.9,18.2,11.2c3-0.6,6-1,9.1-1.3c0,0,0,0,0,0c-9.4-1.2-18.2-5.4-25-12.2 c-6.8-6.8-11.1-15.6-12.2-25c-1.1-0.3-2.3-0.6-3.4-0.8C595.4,260.7,600,270.5,607.7,278.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_41_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_40_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: -273.3421,
    y1: 613.1229,
    x2: -265.3256,
    y2: 613.1229,
    gradientTransform: "matrix(1.7833 3.7204 -3.7204 1.7833 3377.084 180.5675)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0073BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1691,
    style: {
      stopColor: "#006AAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    style: {
      stopColor: "#00507E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00466C"
    }
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "579.1,257.4 602,305.2 650.3,282 627.4,234.2  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_43_",
    d: "M613.9,272c5.2,5.3,11.9,8.8,19.1,10.2c-0.5-1.3-1.1-2.5-1.7-3.8c-5.7-1.6-10.8-4.5-15-8.7 c-4.2-4.2-7.2-9.4-8.7-15c-1.2-0.6-2.5-1.2-3.8-1.7C605.1,260.1,608.6,266.7,613.9,272"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_44_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_43_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: -273.0424,
    y1: 611.3331,
    x2: -265.0259,
    y2: 611.3331,
    gradientTransform: "matrix(1.7735 3.7 -3.7 1.7735 3358.5745 181.2853)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0073BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1691,
    style: {
      stopColor: "#006AAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    style: {
      stopColor: "#00507E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00466C"
    }
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "592.3,258.4 609.1,293.6 644.3,276.7 627.5,241.5  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_46_",
    d: "M595.3,315.3c-2.7,2.7-5.1,5.6-7.2,8.6c0.6,1.1,1.2,2.1,1.8,3.2c2.3-3.4,4.8-6.6,7.7-9.5 c10.6-10.6,24.5-16.8,39.3-17.6c0-1.1-0.2-2.2-0.3-3.3C621.1,297.7,606.5,304.2,595.3,315.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_47_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_46_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: -454.3673,
    y1: 730.0789,
    x2: -446.3508,
    y2: 730.0789,
    gradientTransform: "matrix(-4.813 2.1391 -2.1391 -4.813 1.6502 4791.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0073BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1691,
    style: {
      stopColor: "#006AAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    style: {
      stopColor: "#00507E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00466C"
    }
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "628.9,278.7 576.8,301.8 596.2,345.3 648.2,322.2  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_49_",
    d: "M601.5,321.5c-3.5,3.5-6.5,7.4-8.9,11.6c0.6,1.4,1.1,2.7,1.5,4.1c2.5-4.9,5.7-9.4,9.7-13.4 c8.9-8.9,20.5-14.1,32.9-15c0.1-1.1,0.2-2.2,0.3-3.3C623.6,306.4,611.1,311.9,601.5,321.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_50_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_49_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: -454.7205,
    y1: 728.3683,
    x2: -446.704,
    y2: 728.3683,
    gradientTransform: "matrix(-4.7999 2.1333 -2.1333 -4.7999 1.8766 4780.458)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0073BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1691,
    style: {
      stopColor: "#006AAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    style: {
      stopColor: "#00507E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00466C"
    }
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "629.7,289.1 580.9,310.8 599.9,353.7 648.8,332  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_52_",
    d: "M607.7,327.7c-5.1,5.1-9,11.4-11.2,18.2c0.6,3,0.9,5.6,1.2,9.1c0,0,0,0,0.1,0c1.2-9.4,5.4-18.2,12.2-25 c6.8-6.8,15.5-11.1,25-12.2c0.3-1.1,0.6-2.2,0.8-3.4l0,0C625.2,315.4,615.3,320.1,607.7,327.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_53_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_52_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: -454.7453,
    y1: 726.2317,
    x2: -446.7288,
    y2: 726.2317,
    gradientTransform: "matrix(-4.7984 2.1326 -2.1326 -4.7984 2.473 4780.5649)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0073BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1691,
    style: {
      stopColor: "#006AAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    style: {
      stopColor: "#00507E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00466C"
    }
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "629.3,299.8 581.4,321.1 603,369.6 650.9,348.3  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_55_",
    d: "M613.9,333.9c-5.2,5.2-8.8,11.9-10.2,19.1c1.3-0.5,2.5-1.1,3.8-1.7c1.6-5.7,4.5-10.8,8.7-15 c4.2-4.2,9.4-7.2,15-8.8c0.6-1.2,1.2-2.5,1.7-3.8C625.7,325.1,619.1,328.6,613.9,333.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_56_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_55_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: -455.5554,
    y1: 725.214,
    x2: -447.5389,
    y2: 725.214,
    gradientTransform: "matrix(-4.7679 2.119 -2.119 -4.7679 2.0975 4752.9019)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0073BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1691,
    style: {
      stopColor: "#006AAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    style: {
      stopColor: "#00507E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00466C"
    }
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "628.1,312.8 592.8,328.5 608.5,363.8 643.8,348.1  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_58_",
    d: "M566.9,305c0.9-0.6,1.8-1.3,2.7-2C568.7,303.6,567.8,304.3,566.9,305"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_59_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_58_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: -384.1034,
    y1: 882.6108,
    x2: -376.0869,
    y2: 882.6108,
    gradientTransform: "matrix(-2.8387 -4.9061 4.9061 -2.8387 -4827.7642 967.4278)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0080BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5733,
    style: {
      stopColor: "#005996"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00417C"
    }
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "570.5,304.5 568.9,301.8 566,303.5 567.6,306.2  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_61_",
    d: "M566.9,305c0.9-0.6,1.9-1.3,2.8-2C568.7,303.6,567.8,304.3,566.9,305"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_62_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_61_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: -248.1784,
    y1: 840.5879,
    x2: -240.1619,
    y2: 840.5879,
    gradientTransform: "matrix(4.7159 -4.4385 4.4385 4.7159 -2007.0133 -4747.9395)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0080BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5733,
    style: {
      stopColor: "#005996"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00417C"
    }
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "568.2,306.3 570.6,304 568.3,301.6 565.8,303.9  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_64_",
    d: "M566.9,305c0.9-0.6,1.8-1.3,2.7-2C568.7,303.6,567.8,304.3,566.9,305"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_65_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_64_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: -385.0429,
    y1: 884.2476,
    x2: -377.0264,
    y2: 884.2476,
    gradientTransform: "matrix(-2.7958 -4.8318 4.8318 -2.7958 -4756.064 958.3165)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0080BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5733,
    style: {
      stopColor: "#005996"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00417C"
    }
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "570.5,304.5 568.9,301.8 566,303.5 567.6,306.2  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_67_",
    d: "M625.9,289.4c-2.9,0.6-5.8,1.4-8.6,2.3c-2.2,0.8-2.5,0.9-4.1,1.5c-2,0.8-4,1.7-5.9,2.8 c-1.4,0.7-1.8,0.9-3.2,1.8c-1.7,1-3.3,2.1-4.9,3.2c-1.3,0.9-1.4,1-2.7,2c-2.4,1.9-4.8,3.9-7,6.1c-2.2,2.2-4.3,4.7-6.3,7.2 c0.7,0.9,1.4,1.8,2,2.8c2-2.7,4.2-5.3,6.6-7.7c11.9-12,27.5-19,44.2-20.1c-0.2-0.7-0.6-2.5-0.8-3.2 C632.4,288.3,627.7,288.9,625.9,289.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_68_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_67_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_69_",
    gradientUnits: "userSpaceOnUse",
    x1: -453.9729,
    y1: 731.7128,
    x2: -445.9565,
    y2: 731.7128,
    gradientTransform: "matrix(-4.8289 2.1462 -2.1462 -4.8289 1.5101 4805.1025)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0073BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1691,
    style: {
      stopColor: "#006AAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    style: {
      stopColor: "#00507E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00466C"
    }
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "627.1,268.5 571.5,293.2 591.7,338.7 647.3,314  "
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.2,
    y: 336.5,
    className: "st23",
    width: 3.9,
    height: 20
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "41.8,336.5 44.5,336.5 55.7,349.5 55.7,336.5 59.5,336.5 59.5,356.5 56.8,356.5 45.7,343.5  45.7,356.5 41.8,356.5 "
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "78.3,336.5 82.3,336.5 87.7,350.2 93.2,336.5 97.2,336.5 89.1,356.5 86.4,356.5 "
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "119.8,339.9 119.8,344.1 126,344.1 126,347.5 119.8,347.5 119.8,353.1 128.3,353.1 128.3,356.5  116,356.5 116,336.5 128,336.5 128,339.9 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M148.4,351.2c1.1,1.3,2.9,2.2,4.7,2.2c1.7,0,2.9-1.1,2.9-2.5c0-2.6-3.7-2.9-6.4-4.5c-1.6-0.9-2.8-2.3-2.8-4.6 c0-3.6,3.3-5.6,6.6-5.6c2,0,3.9,0.5,5.8,1.9l-2,2.9c-0.8-0.7-2.1-1.3-3.5-1.3c-1.5,0-3.1,0.6-3.1,2.2c0,3.2,9.2,2.2,9.2,9 c0,3.5-3.2,6-6.8,6c-2.7,0-5.2-1.1-7.2-3L148.4,351.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "192.2,336.5 192.2,339.9 186.9,339.9 186.9,356.5 183.1,356.5 183.1,339.9 177.8,339.9 177.8,336.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M220.4,336.2c6.2,0,10.4,4.6,10.4,10.3c0,5.7-4.3,10.3-10.4,10.3c-6.2,0-10.4-4.6-10.4-10.3 C210,340.8,214.3,336.2,220.4,336.2 M220.4,353.4c3.8,0,6.6-3.1,6.6-6.9c0-3.8-2.8-6.9-6.6-6.9c-3.8,0-6.6,3.1-6.6,6.9 C213.9,350.3,216.7,353.4,220.4,353.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M254.1,347.7v8.9h-3.9v-20h7.3c2.1,0,3.4,0.6,4.4,1.5c1.1,1,1.8,2.5,1.8,4.1c0,1.6-0.7,3.1-1.8,4.1 c-0.5,0.5-1.2,0.9-2,1.2l7.5,9.2h-4.8l-7.1-8.9H254.1z M257.3,344.2c1.1,0,1.6-0.2,1.9-0.6c0.3-0.4,0.6-0.9,0.6-1.5 c0-0.6-0.2-1.2-0.6-1.5c-0.3-0.4-0.8-0.6-1.9-0.6h-3.2v4.3H257.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M286.1,351.2c1.1,1.3,2.9,2.2,4.7,2.2c1.7,0,2.9-1.1,2.9-2.5c0-2.6-3.7-2.9-6.4-4.5c-1.6-0.9-2.8-2.3-2.8-4.6 c0-3.6,3.3-5.6,6.6-5.6c2,0,3.9,0.5,5.8,1.9l-2,2.9c-0.8-0.7-2.1-1.3-3.5-1.3c-1.5,0-3.1,0.6-3.1,2.2c0,3.2,9.2,2.2,9.2,9 c0,3.5-3.2,6-6.8,6c-2.7,0-5.2-1.1-7.2-3L286.1,351.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M343.4,346.5c0,3.9,3,6.9,6.8,6.9c1.8,0,3.3-0.6,4.5-1.5v-4.3h-5.1v-3.4h9v8.9c-1.8,2.3-4.7,3.8-8.4,3.8 c-6.2,0-10.6-4.5-10.6-10.3c0-5.7,4.3-10.3,10.5-10.3c3,0,5.5,1.1,7.3,2.9l-2.5,2.6c-1.2-1.2-2.9-2.1-4.9-2.1 C346.2,339.7,343.4,342.7,343.4,346.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M382.6,347.7v8.9h-3.9v-20h7.3c2.1,0,3.4,0.6,4.4,1.5c1.1,1,1.8,2.5,1.8,4.1c0,1.6-0.7,3.1-1.8,4.1 c-0.5,0.5-1.2,0.9-2,1.2l7.5,9.2h-4.8l-7.1-8.9H382.6z M385.8,344.2c1.1,0,1.6-0.2,1.9-0.6c0.3-0.4,0.6-0.9,0.6-1.5 c0-0.6-0.2-1.2-0.6-1.5c-0.3-0.4-0.8-0.6-1.9-0.6h-3.2v4.3H385.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M423.1,336.2c6.2,0,10.4,4.6,10.4,10.3c0,5.7-4.3,10.3-10.4,10.3c-6.2,0-10.4-4.6-10.4-10.3 C412.6,340.8,416.9,336.2,423.1,336.2 M423.1,353.4c3.8,0,6.6-3.1,6.6-6.9c0-3.8-2.8-6.9-6.6-6.9c-3.8,0-6.6,3.1-6.6,6.9 C416.5,350.3,419.3,353.4,423.1,353.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M455.3,354.8c-1.7-1.5-2.6-3.6-2.6-6.7v-11.6h3.9v11.9c0,1.8,0.5,2.9,1.3,3.7c0.9,0.8,2.1,1.3,3.4,1.3 s2.5-0.5,3.4-1.3c0.8-0.8,1.3-1.9,1.3-3.7v-11.9h3.9v11.6c0,3.1-0.9,5.2-2.6,6.7c-1.5,1.4-3.7,2.1-6,2.1S456.8,356.1,455.3,354.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M494.3,348.4v8.2h-3.9v-20h7.5c2.6,0,4.1,0.6,5.2,1.8c1,1,1.6,2.6,1.6,4.2c0,1.6-0.6,3.1-1.6,4.1 c-1.1,1.1-2.6,1.8-5.2,1.8H494.3z M497.8,344.9c1.3,0,2-0.3,2.4-0.8c0.4-0.5,0.7-1,0.7-1.7c0-0.7-0.2-1.3-0.7-1.7 c-0.5-0.5-1.1-0.8-2.4-0.8h-3.5v5H497.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M47.5,247.5c9.5,0,18.6,3.9,24.4,10.3l-6.4,6.3c-3.9-4.3-10.9-7.5-18-7.5c-13.7,0-24.2,10.9-24.2,25.3 c0,15.1,10.9,25.3,25.1,25.3c9,0,15.5-5,19.2-9.5l6.8,6.1c-5.7,7.4-15.7,12.4-26,12.4c-19.9,0-34.6-14.6-34.6-34.4 C13.7,262.6,28.3,247.5,47.5,247.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M121.8,298.1H93.6l-7,17.2h-9.9l27.7-66.8h6.7l27.7,66.8h-9.9L121.8,298.1z M97.4,289.1h20.6l-10.3-24.8 L97.4,289.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "157.4,266.2 157.4,315.3 147.8,315.3 147.8,248.5 154.5,248.5 194.6,297.6 194.6,248.5 204.2,248.5  204.2,315.3 197.5,315.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M221.3,315.3v-66.8h20c10.6,0,17.5,2.3,22.9,6.3c8.2,6.1,13.4,16,13.4,27.1c0,11.1-5.1,21-13.3,27.1 c-5.4,4-12.4,6.3-23,6.3H221.3z M260,263.2c-4.2-3.6-9.7-5.6-19.1-5.6h-10v48.7h10c9.3,0,14.9-2,19.1-5.6 c5.1-4.5,8.1-11.3,8.1-18.7C268.1,274.5,265,267.7,260,263.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M299.1,283.8v31.5h-9.5v-66.8H313c6.1,0,9.9,1.4,13,3.9c4,3.2,6.6,8.2,6.6,13.7c0,5.5-2.6,10.5-6.6,13.7 c-2.1,1.7-4.5,3-7.8,3.5l24,31.9h-11.6l-23.8-31.5H299.1z M312.5,274.7c4.3,0,6.5-1,8-2.5c1.5-1.5,2.5-3.7,2.5-6.1 c0-2.4-1-4.6-2.5-6.1c-1.5-1.5-3.7-2.5-8-2.5h-13.4v17.2H312.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.7,
    y: 248.5,
    className: "st24",
    width: 9.5,
    height: 66.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M414.3,298.1h-28.2l-7,17.2h-9.9l27.7-66.8h6.7l27.7,66.8h-9.9L414.3,298.1z M390,289.1h20.6l-10.3-24.8 L390,289.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st24",
    points: "476.2,301 469.5,301 449.9,270.4 449.9,315.3 440.4,315.3 440.4,248.5 447.1,248.5 472.8,289.3  498.6,248.5 505.3,248.5 505.3,315.3 495.7,315.3 495.7,270.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 372.1,
    className: "st25",
    width: 620.5,
    height: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M14.2,407.4l8.6-20h2.7l8.6,20h-4l-1.9-4.4h-8l-1.9,4.4H14.2z M21.5,399.6h5.1l-2.5-5.9L21.5,399.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "64.7,387.4 67.5,387.4 78.6,400.5 78.6,387.4 82.5,387.4 82.5,407.4 79.8,407.4 68.6,394.4  68.6,407.4 64.7,407.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "101.3,390.8 101.3,395 107.4,395 107.4,398.4 101.3,398.4 101.3,404 109.7,404 109.7,407.4  97.4,407.4 97.4,387.4 109.4,387.4 109.4,390.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "121.5,387.4 125.4,387.4 129.5,399.9 133.9,387.4 136.6,387.4 141,399.9 145.2,387.4 149.1,387.4  142.4,407.4 139.7,407.4 135.3,394.8 130.8,407.4 128.1,407.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "188.6,398.4 188.6,407.4 184.8,407.4 184.8,398.4 177.9,387.4 182.3,387.4 186.7,394.4 191.1,387.4  195.5,387.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M217.3,387.1c6.2,0,10.4,4.6,10.4,10.3s-4.3,10.3-10.4,10.3c-6.2,0-10.4-4.6-10.4-10.3 S211.1,387.1,217.3,387.1 M217.3,404.3c3.8,0,6.6-3.1,6.6-6.9c0-3.8-2.8-6.9-6.6-6.9c-3.8,0-6.6,3.1-6.6,6.9 C210.7,401.2,213.5,404.3,217.3,404.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M245.1,398.6v8.9h-3.9v-20h7.3c2.1,0,3.4,0.6,4.4,1.5c1.1,1,1.8,2.5,1.8,4.1c0,1.6-0.7,3.1-1.8,4.1 c-0.5,0.5-1.2,0.9-2,1.2l7.5,9.2h-4.8l-7.1-8.9H245.1z M248.3,395.1c1.1,0,1.6-0.2,1.9-0.6c0.3-0.4,0.6-0.9,0.6-1.5 c0-0.6-0.2-1.2-0.6-1.5c-0.3-0.4-0.8-0.6-1.9-0.6h-3.2v4.3H248.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "274.6,397.6 274.6,407.4 270.7,407.4 270.7,387.4 274.6,387.4 274.6,395.4 282.2,387.4 287.3,387.4  278.5,396.6 288.3,407.4 283.4,407.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "319,387.4 322.9,387.4 322.9,404 331.3,404 331.3,407.4 319,407.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.7,
    y: 387.4,
    className: "st25",
    width: 3.9,
    height: 20
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "367.3,390.8 367.3,395 373.5,395 373.5,398.4 367.3,398.4 367.3,407.4 363.5,407.4 363.5,387.4  375.5,387.4 375.5,390.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "392.6,390.8 392.6,395 398.7,395 398.7,398.4 392.6,398.4 392.6,404 401,404 401,407.4 388.7,407.4  388.7,387.4 400.7,387.4 400.7,390.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M435.3,397.4c0,3.9,3,6.9,6.8,6.9c2.6,0,4.5-1.3,5.7-2.8l2.7,2.4c-1.8,2.3-4.7,3.8-8.4,3.8 c-6.2,0-10.6-4.5-10.6-10.3c0-5.7,4.3-10.3,10.5-10.3c3,0,5.5,1.1,7.3,2.9l-2.5,2.6c-1.2-1.2-2.9-2.1-4.9-2.1 C438.1,390.6,435.3,393.6,435.3,397.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M472.7,387.1c6.2,0,10.4,4.6,10.4,10.3s-4.3,10.3-10.4,10.3c-6.2,0-10.4-4.6-10.4-10.3 S466.5,387.1,472.7,387.1 M472.7,404.3c3.8,0,6.6-3.1,6.6-6.9c0-3.8-2.8-6.9-6.6-6.9c-3.8,0-6.6,3.1-6.6,6.9 C466.1,401.2,468.9,404.3,472.7,404.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "506.6,399.4 513.9,387.4 516.6,387.4 516.6,407.4 512.7,407.4 512.7,396.3 507.9,404.1 505.3,404.1  500.5,396.3 500.5,407.4 496.6,407.4 496.6,387.4 499.3,387.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M535.4,399.3v8.2h-3.9v-20h7.5c2.6,0,4.1,0.6,5.2,1.8c1,1,1.6,2.6,1.6,4.2c0,1.6-0.6,3.1-1.6,4.1 c-1.1,1.1-2.6,1.8-5.2,1.8H535.4z M538.9,395.9c1.3,0,2-0.3,2.4-0.8c0.4-0.5,0.7-1,0.7-1.7c0-0.7-0.2-1.3-0.7-1.7 c-0.5-0.5-1.1-0.8-2.4-0.8h-3.5v5H538.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M556.8,407.4l8.6-20h2.7l8.6,20h-4l-1.9-4.4h-8l-1.9,4.4H556.8z M564.1,399.6h5.1l-2.5-5.9L564.1,399.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "589.3,387.4 592,387.4 603.1,400.5 603.1,387.4 607,387.4 607,407.4 604.3,407.4 593.1,394.4  593.1,407.4 589.3,407.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "630.5,398.4 630.5,407.4 626.6,407.4 626.6,398.4 619.8,387.4 624.2,387.4 628.6,394.4 633,387.4  637.4,387.4  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_70_",
    d: "M566.9,305c0.7,0.5,1.3,1,2,1.5c0,0,0,0,0.1,0.1c0.6,0.5,1.2,1,1.8,1.5c0.2,0.1,0.3,0.3,0.5,0.4 c0.5,0.4,0.9,0.8,1.4,1.2c0.6,0.6,1.2,1.2,1.8,1.8c12,12,19,27.6,20.1,44.4c0.7-0.2,2.5-0.6,3.2-0.8c-0.2-2.3-0.6-6-1.2-9.1 c-0.6-3-1.4-5.8-2.3-8.7c-0.3-1.1-1.3-3.5-1.5-4.1c-0.8-2-1.7-4-2.7-5.9c-0.6-1.3-1.3-2.4-1.8-3.2c-1-1.7-2-3.3-3.1-4.9 c-0.5-0.7-1.4-2-2-2.8c-1.9-2.5-4-4.9-6.3-7.2c-0.6-0.6-1.2-1.1-1.8-1.7c-0.4-0.4-0.8-0.8-1.3-1.2c-0.2-0.1-0.3-0.3-0.5-0.4 c-0.6-0.5-1.1-1-1.7-1.4c0,0,0,0-0.1-0.1c-0.6-0.5-1.2-1-1.8-1.5C568.7,303.6,567.8,304.3,566.9,305"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_71_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_70_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_72_",
    gradientUnits: "userSpaceOnUse",
    x1: -384.7794,
    y1: 883.6134,
    x2: -376.7629,
    y2: 883.6134,
    gradientTransform: "matrix(-2.8099 -4.8562 4.8562 -2.8099 -4779.6621 961.3813)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0073BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1691,
    style: {
      stopColor: "#006AAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7222,
    style: {
      stopColor: "#00507E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00466C"
    }
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "620.6,342.6 590,289.6 543.9,316.2 574.6,369.2  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandriam);
export default __webpack_public_path__ + "static/media/candriam.fbfdde361ad84f35ec1c66fd736caa76.svg";
export { ForwardRef as ReactComponent };